import CryptoJS from "crypto-js";

const CommonCrypt = (encryptedData) => {
    const key = CryptoJS.enc.Utf8.parse("b809vCwvtawRbsG0BmP1tWgnlXQypSKf"); // Convert key to WordArray
    const iv = CryptoJS.enc.Utf8.parse("123*456@7894#%^*"); // Convert IV to WordArray

    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
};

export default CommonCrypt;